(function () {
  var drawer = null;
  var main = null;
  var ticking = false;

  function blocked() {
    var viewport = document.querySelector(".layout--viewport");
    var cart = document.getElementById("rebuy-cart");
    return (
      (viewport && /^open/.test(viewport.getAttribute("data-drawer-status"))) ||
      (cart && cart.getAttribute("aria-hidden") === "false") ||
      document.querySelector("[data-popup-status='open'], dialog[open]") !== null
    );
  }

  function refresh() {
    ticking = false;
    if (!drawer || !main || blocked()) return;
    var box = main.getBoundingClientRect();
    if (box.top <= window.innerHeight) return;
    if (drawer.getAttribute("aria-hidden") !== "false") drawer.setAttribute("aria-hidden", "false");
  }

  function schedule() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(refresh);
  }

  function init() {
    drawer = document.querySelector(".main-product--root .product-buy-buttons--drawer");
    main = document.querySelector(".main-product--root .product-buy-buttons--primary");
    if (!drawer || !main || main.closest(".product-buy-buttons--drawer")) return;
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule, { passive: true });
    schedule();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
